import { EMPTY_OBJECT } from '../constants/common'
import {
  addRedesignContextApiParam,
  callFileApi,
  callFileApiV3,
  deleteApi,
  getApi,
  getId2IdEndpoint,
  postApi,
} from '../utils/api'

export function getFileById({ id, outboundUuid, params }) {
  return getApi({
    endpoint: getId2IdEndpoint({ outboundUuid, path: `v2/file/${id}/` }),
    params,
  })
}

export function getFileViewLogs(fileId, data) {
  return postApi({
    data,
    endpoint: `api/v4/file/${fileId}/logs/`,
  })
}

export function getFileItems(params, { outboundUuid } = EMPTY_OBJECT) {
  return getApi({
    endpoint: getId2IdEndpoint({ outboundUuid, path: 'v2/file/' }),
    params: addRedesignContextApiParam(params),
  })
}

export function sendFileMetaDataV3({ data, outboundUuid }) {
  return postApi({
    data,
    endpoint: getId2IdEndpoint({ outboundUuid, path: 'v3/file/' }),
  })
}

export function uploadFileV3({ data, endpoint }) {
  return callFileApiV3({ data, endpoint })
}

export function fileUploadedCallbackV3({ id, outboundUuid }) {
  return postApi({
    endpoint: getId2IdEndpoint({
      outboundUuid,
      path: `v3/file/${id}/callback_on_upload/`,
    }),
  })
}

export function deleteFileV3(id, { outboundUuid } = EMPTY_OBJECT) {
  const endpoint = outboundUuid
    ? getId2IdEndpoint({ outboundUuid, path: `v3/file/${id}/` })
    : `api/v3/file/${id}/`

  return deleteApi({ endpoint })
}

export function massDownloadFile({ data, outboundUuid }) {
  return postApi({
    data,
    endpoint: getId2IdEndpoint({ outboundUuid, path: 'file/mass_download/' }),
  })
}

export function checkFileDownloadTask({ outboundUuid, taskId }) {
  return getApi({
    endpoint: getId2IdEndpoint({
      outboundUuid,
      path: `file/mass_download/${taskId}/`,
    }),
  })
}

export function checkSystemAsyncTask({ id }) {
  return getApi({ endpoint: `api/system/async_task/${id}/` })
}

export function deleteFileDocument(id) {
  return deleteApi({ endpoint: `api/v2/document/${id}/` })
}

export function downloadFileDocumentById({ id, outboundUuid, params }) {
  return getApi({
    endpoint: getId2IdEndpoint({
      outboundUuid,
      path: `v2/document/${id}/download/`,
    }),
    params,
  })
}

export function getFileDocumentById({ id, outboundUuid, params }) {
  return getApi({
    endpoint: getId2IdEndpoint({ outboundUuid, path: `v2/document/${id}/` }),
    params,
  })
}

export function uploadFileDocument(file) {
  return callFileApi({
    data: file,
    endpoint: 'api/v2/document/',
    method: 'POST',
  })
}

export function getFileDocumentSignedLink({ id, options, params }) {
  return getApi({
    endpoint: `api/v2/document/${id}/origin-url/`,
    options,
    params: {
      ...params,
      ensure_urls_signed: true,
    },
  })
}
